// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2364":"aa0d566f","3259":"ab63567b","3314":"af874031","8509":"70f7a4a3","9532":"29d015e6"}[chunkId] + ".js";
};